import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import i18n from 'simple-react-i18n'
import { getDate } from '../../../utils/DateUtil'
import PluviometryAction from '../../actions/PluviometryAction'
import DtoPluviometerStats from '../../dto/DtoPluviometerStats'
import { Grid, Paper, Tooltip } from '@mui/material'
import { orderBy } from 'lodash'
import { NewTable } from '../../../components/datatable/NewTable'
import InfoIcon from '@mui/icons-material/Info'

const PluviometerStatisticPanel = ({
    id,
}) => {
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(PluviometryAction.fetchPluviometerMeasuresStats(id))
    }, [dispatch, id])

    const {
        pluviometerStatistics,
    } = useSelector(store => ({
        pluviometerStatistics: store.PluviometryReducer.pluviometerStatistics,
    }), shallowEqual)

    const data = orderBy(pluviometerStatistics, ['order', 'typeId'], 'asc').map(stat => {
        const comment = stat?.comment ? (
            <Tooltip title={ stat.comment}>
                <InfoIcon
                    style={{ fontSize: 18, color: 'grey' } }
                />
            </Tooltip>
        ) : ''
        return {
            label: <Grid container spacing={1} fontWeight={'bold'} alignItems={'center'}>{stat.label} {comment}</Grid>,
            isMultiPoint: stat.namePoint ?? ' ',
            startDate: getDate(stat.startDate),
            endDate: getDate(stat.endDate),
            countTotal: stat.countTotal === -1 ? i18n.calculatedMeasures : stat.countTotal,
        }
    })

    const headers = [
        { key: 'label', value: i18n.statistics },
        { key: 'isMultiPoint', value: i18n.pointPrelevement },
        { key: 'startDate', value: i18n.begin },
        { key: 'endDate', value: i18n.end },
        { key: 'countTotal', value: i18n.nbMeasures },
    ].filter(s => !!s)


    return (
        <Paper variant='outlined'>
            <NewTable
                rows={data}
                rowsPerPageOptions={-1}
                headers={headers}
            />
        </Paper>
    )
}

PluviometerStatisticPanel.propTypes = {
    id: PropTypes.string.isRequired,
    pluviometerStatistics: PropTypes.arrayOf(PropTypes.instanceOf(DtoPluviometerStats)),
    fetchPluviometerMeasuresStats: PropTypes.func,
}

export default PluviometerStatisticPanel